import React, { Dispatch, ReactNode, SetStateAction, useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { pathnameWithParameters } from '../../utils/location';
import { Carousel, CarouselItem } from '../carousel';
import { TabType, Tabs } from '../tabs';

type LavvaDetailsWrapperProps = {
  children: ReactNode;
  tabs?: TabType[];
  preventSwipeEvent?: boolean;
  additionalTabs?: ReactNode[];
  underTabs?: { component: ReactNode; index: number };
  overwriteTabIndex?: number;
  setOverwriteActiveTabIndex?: Dispatch<SetStateAction<number>>;
};

const LavvaDetailsWrapper: React.FC<LavvaDetailsWrapperProps> = ({
  preventSwipeEvent = false,
  children,
  tabs = [],
  additionalTabs,
  underTabs,
  overwriteTabIndex,
  setOverwriteActiveTabIndex,
}) => {
  const navigate = useNavigate();
  const { pathname, search } = useLocation();
  const [activeTabIndex, setActiveTabIndex] = useState<number>(-1);
  const currentTabIndex = overwriteTabIndex !== undefined ? overwriteTabIndex : activeTabIndex;

  useEffect(() => {
    const tabNameParam = new URLSearchParams(search).get('tabName');
    let tabIndex: number | null = null;

    if (tabNameParam) {
      const tabNameIndex = tabs.findIndex((x) => x.name === tabNameParam);
      if (tabNameIndex !== -1) tabIndex = tabNameIndex;
    } else {
      const tabParam = new URLSearchParams(search).get('tab');
      if (tabParam) tabIndex = parseInt(tabParam);
    }

    if (tabIndex != null) {
      if (setOverwriteActiveTabIndex) setOverwriteActiveTabIndex(tabIndex);
      else setActiveTabIndex(tabIndex);
    } else {
      if (setOverwriteActiveTabIndex) setOverwriteActiveTabIndex(0);
      else setActiveTabIndex(0);
    }
  }, [tabs.length]);

  const changeActiveTab = (index: number) => {
    if (setOverwriteActiveTabIndex) setOverwriteActiveTabIndex(index);
    else setActiveTabIndex(index);

    const name = tabs[index].name;

    navigate(
      pathnameWithParameters(
        pathname,
        search,
        !name
          ? {
              key: 'tab',
              value: index,
            }
          : { key: 'tabName', value: name },
      ),
      { replace: true },
    );
  };

  return (
    <>
      {additionalTabs?.length ? (
        <>
          <Tabs
            tabList={tabs}
            activeTabIndex={currentTabIndex}
            setActiveTabIndex={changeActiveTab}
            tabsType="pills"
            isDivider={false}
            fullWidth
          />
          {underTabs?.index === currentTabIndex && underTabs.component}
          <div className="details-page">
            <Carousel
              preventSwipeEvent={preventSwipeEvent}
              setActiveIndex={changeActiveTab}
              activeIndex={currentTabIndex}
            >
              <CarouselItem key={1}>{children}</CarouselItem>
              {additionalTabs.map((Component: ReactNode, index: number) => (
                <CarouselItem key={index}>{Component}</CarouselItem>
              ))}
            </Carousel>
          </div>
        </>
      ) : (
        <div className="details-page">{children}</div>
      )}
    </>
  );
};

export default LavvaDetailsWrapper;
